import React from 'react'

const Context = React.createContext('cyan')

export default Context